var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-link-wrapper",class:{ 'is-animated': _vm.isAnimated }},[_c('router-link',{staticClass:"brand-link",attrs:{"to":{ name: 'Product', params: { slug: this.slug } }}},[_c('span',[_vm._v("Подробнее")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }